import type { ComponentProps } from 'react';
import { Link } from 'react-router-dom';

/**
 * Adapter für `linkAs` der Komponenten aus @elbklar/ui (Sidebar, PageHeader):
 * Sie geben `href`, react-router will `to`.
 */
export function RouterLink({ href, ...rest }: { href: string } & Omit<ComponentProps<typeof Link>, 'to'>) {
  return <Link to={href} {...rest} />;
}
